import Vuex from 'vuex'
import Profile from '@store/modules/Profile'
import Triplog from '@store/modules/Triplog'
import Statistic from '@store/modules/Statistic'
import CarHealth from '@store/modules/CarHealth'
import Settings from '@store/modules/Settings'
import Membership from '@store/modules/Membership'
import Geographics from '@/store/modules/Geographics'
import Favorite from '@/store/modules/Favorite'

const store = {
  modules: {
    Profile,
    Triplog,
    Statistic,
    CarHealth,
    Settings,
    Membership,
    Geographics,
    Favorite
  },
}

export const createStore = () => new Vuex.Store(store) // eslint-disable-line import/prefer-default-export
